module.exports = __webpack_public_path__ + "img/bookcase-xl.117411c7.svg";